import { render } from "./InfoBar.vue?vue&type=template&id=1a132776&ts=true"
import script from "./InfoBar.vue?vue&type=script&lang=ts"
export * from "./InfoBar.vue?vue&type=script&lang=ts"

import "./InfoBar.vue?vue&type=style&index=0&id=1a132776&lang=css"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__